import { z } from "zod";
//#region src/api/orpc/shared/safetyScore.ts
/** Discrete moderation safety score; SmallInt bin in [1, 9]. */
const safetyScoreSchema = z.number().int().min(1).max(9);
//#endregion
export { safetyScoreSchema };
